import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { OcNotFoundComponent } from 'otimus-library'
import { AppLayoutComponent } from './containers/app-layout/app-layout.component'
import { EmptyContainerComponent } from './containers/empty-container/empty-container.component'
import { PageContainerComponent } from './containers/page-container/page-container.component'
import { ResponsiveContainerComponent } from './containers/responsive-container/responsive-container.component'
import { InternationalizationGuard } from './guards/internationalization.guard'
import { jwtAuthGuard } from './guards/jwt-auth.guard'
import { logoutGuard } from './guards/logout.guard'
import { ServerUrlGuard } from './guards/server-url.guard'
import { unlinkGuard } from './guards/unlink.guard'
import { GXContainerComponent } from './modules/gx-loader/containers/gx-container/gx-container.component'
// DENSE_VIEW_MOCK
import {
  DensePreviewComponent,
} from './modules/patient-service/pages/multi-schedule/dense-preview/dense-preview.component'

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

  // DENSE_VIEW_MOCK: standalone preview without any guard or backend dependency
  {
    path: 'dense-preview',
    component: DensePreviewComponent,
  },

  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'supplies',
        loadChildren: () =>
          import('./modules/supplies/supplies.module').then((m) => m.SuppliesModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'reports',
        loadChildren: () => import('./modules/reports/reports.module').then((m) => m.ReportsModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'chart',
        loadChildren: () => import('./modules/chart/chart.module').then((m) => m.ChartModule),
      },
    ],
  },
  {
    path: '',
    component: ResponsiveContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'mobile',
        loadChildren: () => import('./modules/mobile/mobile.module').then((m) => m.MobileModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'import-excel-medical-guide',
        loadChildren: () =>
          import('./modules/import-excel-medical-guide/import-excel-medical-guide.module').then(
            (m) => m.ImportExcelMedicalGuideModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'integrations',
        loadChildren: () =>
          import('./modules/integration/integration.module').then((m) => m.IntegrationsModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'drawer',
        loadChildren: () => import('./modules/drawer/drawer.module').then((m) => m.DrawerModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'report-models',
        loadChildren: () =>
          import('./modules/report-models/report-models.module').then((m) => m.ReportModelsModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'parameters',
        loadChildren: () =>
          import('./modules/parameters/parameters.module').then((m) => m.ParametersModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'medical-report',
        loadChildren: () =>
          import('./modules/medical-report/medical-report.module').then(
            (m) => m.MedicalReportModule
          ),
      },
    ],
  },
  {
    path: '',
    component: PageContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'billing',
        loadChildren: () => import('./modules/billing/billing.module').then((m) => m.BillingModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'custom',
        loadChildren: () => import('./modules/custom/custom.module').then((m) => m.CustomModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'masterkey',
        loadChildren: () =>
          import('./modules/masterkey/masterkey.module').then((m) => m.MasterkeyModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    children: [
      {
        path: 'eligibility',
        loadChildren: () =>
          import('./modules/eligibility/eligibility.module').then((m) => m.EligibilityModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'configuration',
        loadChildren: () =>
          import('./modules/configuration/configuration.module').then((m) => m.ConfigurationModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'patient-service',
        loadChildren: () =>
          import('./modules/patient-service/patient-service.module').then(
            (m) => m.PatientServiceModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'parameters',
        loadChildren: () =>
          import('./modules/parameters/parameters.module').then((m) => m.ParametersModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'exams',
        loadChildren: () => import('./modules/exams/exams.module').then((m) => m.ExamsModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'migrate',
        loadChildren: () =>
          import('./modules/migrate/migrate-appointment.module').then(
            (m) => m.MigrateAppointmentModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'score',
        loadChildren: () => import('./modules/score/score.module').then((m) => m.ScoreModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'service',
        loadChildren: () => import('./modules/service/service.module').then((m) => m.ServiceModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    children: [
      {
        path: 'login',
        loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'command-center',
        loadChildren: () =>
          import('./modules/command-center/command-center.module').then(
            (m) => m.CommandCenterModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'bulletin-board',
        loadChildren: () =>
          import('./modules/bulletin-board/bulletin-board.module').then(
            (m) => m.BulletinBoardModule
          ),
      },
    ],
  },
  {
    path: 'care-plan',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    loadChildren: () =>
      import('./modules/care-plan/care-plan.module').then((m) => m.CarePlanModule),
  },
  {
    path: 'transfer-scheduling',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    loadChildren: () =>
      import('./modules/transfer-scheduling/transfer-scheduling/transfer-scheduling.module').then(
        (m) => m.TransferSchedulingModule
      ),
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'bulletin-board',
        loadChildren: () =>
          import('./modules/bulletin-board/bulletin-board.module').then(
            (m) => m.BulletinBoardModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'additional-fields',
        loadChildren: () =>
          import('./modules/additional-fields/additional-fields.module').then(
            (m) => m.AdditionalFieldsModule
          ),
      },
    ],
  },
  {
    path: '',
    component: EmptyContainerComponent,
    canActivate: [InternationalizationGuard],
    children: [
      {
        path: 'import-professional',
        loadChildren: () =>
          import('./modules/import-professional/import-professional.module').then(
            (m) => m.ImportProfessionalModule
          ),
      },
    ],
  },
  {
    path: 'tools/uploader',
    component: EmptyContainerComponent,
    loadChildren: () => import('./modules/uploads/uploads.module').then((m) => m.UploadsModule),
  },
  {
    path: 'logout',
    canActivate: [logoutGuard],
    component: EmptyContainerComponent,
  },
  {
    path: 'unlink',
    canActivate: [ServerUrlGuard, unlinkGuard],
    component: EmptyContainerComponent,
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [ServerUrlGuard],
    children: [
      {
        component: GXContainerComponent,
        path: 'gx',
        canActivate: [jwtAuthGuard],
        loadChildren: () =>
          import('./modules/gx-loader/gx-loader.module').then((m) => m.GXLoaderModule),
      },
      {
        path: 'app',
        canActivate: [jwtAuthGuard],
        children: [
          {
            path: 'patient-service',
            loadChildren: () =>
              import('./modules/patient-service/patient-service.module').then(
                (m) => m.PatientServiceModule
              ),
          },
          {
            path: 'dashboard',
            loadChildren: () =>
              import('./modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
          },
          {
            path: 'configuration',
            loadChildren: () =>
              import('./modules/configuration/configuration.module').then(
                (m) => m.ConfigurationModule
              ),
          },
          {
            path: 'integrations',
            loadChildren: () =>
              import('./modules/integration/integration.module').then((m) => m.IntegrationsModule),
          },
          {
            path: 'tools/uploader',
            loadChildren: () =>
              import('./modules/uploads/uploads.module').then((m) => m.UploadsModule),
          },
        ],
      },
    ],
  },
  //Novas Rotas devem ser adicionadas SOMENTE ACIMA destas
  { path: '**', redirectTo: '404' },
  { path: '404', component: OcNotFoundComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
